import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrash,
    faEdit,
    faPlus,
    faUsers,
    faImage,
    faSpinner,
    faTimes
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './QuienesSomosData.css';

export default function QuienesSomosData() {
    const [items, setItems] = useState([]);
    const [cargando, setCargando] = useState(true);

    // Modal Crear
    const [modalCrear, setModalCrear] = useState(false);
    const [tituloCrear, setTituloCrear] = useState('');
    const [descripcionCrear, setDescripcionCrear] = useState('');
    const [imagenCrear, setImagenCrear] = useState(null);
    const [previewCrear, setPreviewCrear] = useState(null);
    const fileInputCrearRef = useRef(null);

    // Modal Editar
    const [modalEditar, setModalEditar] = useState(false);
    const [idEditar, setIdEditar] = useState(null);
    const [tituloEditar, setTituloEditar] = useState('');
    const [descripcionEditar, setDescripcionEditar] = useState('');
    const [imagenEditar, setImagenEditar] = useState(null);
    const [previewEditar, setPreviewEditar] = useState(null);
    const [imagenActual, setImagenActual] = useState('');
    const fileInputEditarRef = useRef(null);

    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        setCargando(true);
        try {
            const res = await fetch(`${baseURL}/quienesSomosGet.php`, {
                method: 'GET',
            });
            const data = await res.json();
            setItems(data.quienesSomos || []);
        } catch (error) {
            console.error('Error al cargar Quiénes Somos:', error);
            toast.error('Error al cargar información de Quiénes Somos');
        } finally {
            setCargando(false);
        }
    };

    // Manejo de imagen en Crear
    const handleImagenCrearChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagenCrear(file);
            setPreviewCrear(URL.createObjectURL(file));
        }
    };

    const limpiarImagenCrear = () => {
        setImagenCrear(null);
        setPreviewCrear(null);
        if (fileInputCrearRef.current) {
            fileInputCrearRef.current.value = '';
        }
    };

    // Manejo de imagen en Editar
    const handleImagenEditarChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagenEditar(file);
            setPreviewEditar(URL.createObjectURL(file));
        }
    };

    const limpiarImagenEditar = () => {
        setImagenEditar(null);
        setPreviewEditar(null);
        if (fileInputEditarRef.current) {
            fileInputEditarRef.current.value = '';
        }
    };

    // Abrir modal crear
    const abrirModalCrear = () => {
        setTituloCrear('');
        setDescripcionCrear('');
        limpiarImagenCrear();
        setModalCrear(true);
    };

    const cerrarModalCrear = () => {
        setModalCrear(false);
        limpiarImagenCrear();
    };

    // Abrir modal editar
    const abrirModalEditar = (item) => {
        setIdEditar(item.idQuienesSomos);
        setTituloEditar(item.titulo || '');
        setDescripcionEditar(item.descripcion || '');
        setImagenActual(item.imagen || '');
        limpiarImagenEditar();
        setModalEditar(true);
    };

    const cerrarModalEditar = () => {
        setModalEditar(false);
        limpiarImagenEditar();
    };

    // Guardar nuevo registro
    const handleCrear = async (e) => {
        e.preventDefault();
        if (!tituloCrear.trim()) {
            toast.warning('Por favor ingrese el título');
            return;
        }
        if (!descripcionCrear.trim()) {
            toast.warning('Por favor ingrese la descripción');
            return;
        }

        setEnviando(true);
        const formData = new FormData();
        formData.append('titulo', tituloCrear.trim());
        formData.append('descripcion', descripcionCrear.trim());
        if (imagenCrear) {
            formData.append('imagen', imagenCrear);
        }

        try {
            const res = await fetch(`${baseURL}/quienesSomosPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });
            const data = await res.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                cerrarModalCrear();
                cargarDatos();
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al guardar:', error);
            toast.error('Error de conexión al guardar el registro');
        } finally {
            setEnviando(false);
        }
    };

    // Actualizar registro existente
    const handleEditar = async (e) => {
        e.preventDefault();
        if (!tituloEditar.trim()) {
            toast.warning('El título no puede estar vacío');
            return;
        }
        if (!descripcionEditar.trim()) {
            toast.warning('La descripción no puede estar vacía');
            return;
        }

        setEnviando(true);
        const formData = new FormData();
        formData.append('idQuienesSomos', idEditar);
        formData.append('titulo', tituloEditar.trim());
        formData.append('descripcion', descripcionEditar.trim());
        if (imagenEditar) {
            formData.append('imagen', imagenEditar);
        }

        try {
            const res = await fetch(`${baseURL}/quienesSomosPut.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });
            const data = await res.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                cerrarModalEditar();
                cargarDatos();
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al actualizar:', error);
            toast.error('Error de conexión al actualizar el registro');
        } finally {
            setEnviando(false);
        }
    };

    // Eliminar registro
    const handleEliminar = (idQuienesSomos, titulo) => {
        Swal.fire({
            title: '¿Eliminar este registro?',
            text: `Se eliminará "${titulo}" y su foto del sistema. ¡No podrás revertir esto!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/quienesSomosDelete.php?idQuienesSomos=${idQuienesSomos}`, {
                        method: 'DELETE',
                        credentials: 'include',
                    });
                    const data = await res.json();

                    if (data.mensaje) {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarDatos();
                    } else if (data.error) {
                        Swal.fire('Error', data.error, 'error');
                    }
                } catch (error) {
                    console.error('Error al eliminar:', error);
                    toast.error('Error de conexión al eliminar');
                }
            }
        });
    };

    return (
        <div className="NewContain">
            <ToastContainer />

            {/* Cabecera con botón Agregar y contador */}
            <div className="quienesHeaderActions">
                <button onClick={abrirModalCrear} className="btnSave" type="button">
                    <FontAwesomeIcon icon={faPlus} /> Agregar
                </button>
                <span className="quienesCountBadge">
                    <FontAwesomeIcon icon={faUsers} /> Secciones ({items.length})
                </span>
            </div>

            {/* Tabla de registros */}
            {cargando ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                    <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                    <p style={{ marginTop: '10px' }}>Cargando información de Quiénes Somos...</p>
                </div>
            ) : items.length === 0 ? (
                <div className="quienesEmpty">
                    <div className="quienesEmptyIcon">
                        <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <h4>No hay información de "Quiénes Somos" registrada</h4>
                    <p>Haz clic en el botón <strong>+ Agregar</strong> para añadir la primera sección con título, descripción y foto.</p>
                    <button onClick={abrirModalCrear} className="btnSave" type="button">
                        <FontAwesomeIcon icon={faPlus} /> Agregar Ahora
                    </button>
                </div>
            ) : (
                <div className="table-container">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Foto</th>
                                <th>Título</th>
                                <th>Descripción</th>
                                <th>Fecha</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item) => (
                                <tr key={item.idQuienesSomos}>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.imagen ? (
                                            <a href={item.imagen} target="_blank" rel="noopener noreferrer" title="Ver foto completa">
                                                <img
                                                    src={item.imagen}
                                                    alt={item.titulo}
                                                    className="quienesThumb"
                                                />
                                            </a>
                                        ) : (
                                            <span className="quienesNoImage">
                                                <FontAwesomeIcon icon={faImage} /> Sin foto
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ fontWeight: 600, color: '#0f172a' }}>
                                        {item.titulo}
                                    </td>
                                    <td>
                                        <div className="quienesDescCell" title={item.descripcion}>
                                            {item.descripcion}
                                        </div>
                                    </td>
                                    <td style={{ fontSize: '0.85rem', color: '#64748b', whiteSpace: 'nowrap' }}>
                                        {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-'}
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <button
                                                className="btnEdit"
                                                type="button"
                                                title="Editar sección"
                                                onClick={() => abrirModalEditar(item)}
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                                className="btnDelete"
                                                type="button"
                                                title="Eliminar sección"
                                                onClick={() => handleEliminar(item.idQuienesSomos, item.titulo)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* MODAL CREAR */}
            {modalCrear && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="deFlexBack">
                            <h4>Agregar Quiénes Somos</h4>
                            <span className="close" onClick={cerrarModalCrear}>
                                &times;
                            </span>
                        </div>
                        <form className="sectiontext" onSubmit={handleCrear}>
                            <div className="flexGrap">
                                <fieldset style={{ width: '100%' }}>
                                    <legend>Título</legend>
                                    <input
                                        type="text"
                                        placeholder="Ej: ¿Quiénes Somos? / Misión y Visión"
                                        value={tituloCrear}
                                        onChange={(e) => setTituloCrear(e.target.value)}
                                        required
                                    />
                                </fieldset>

                                <fieldset style={{ width: '100%' }}>
                                    <legend>Descripción</legend>
                                    <textarea
                                        rows="6"
                                        placeholder="Describe la información de Quiénes Somos, objetivos, historia o mensaje de la empresa..."
                                        value={descripcionCrear}
                                        onChange={(e) => setDescripcionCrear(e.target.value)}
                                        required
                                        style={{ resize: 'vertical', minHeight: '120px' }}
                                    />
                                </fieldset>

                                <fieldset style={{ width: '100%' }}>
                                    <legend>Foto / Imagen</legend>
                                    <input
                                        type="file"
                                        accept="image/jpeg,image/png,image/webp,image/gif"
                                        ref={fileInputCrearRef}
                                        onChange={handleImagenCrearChange}
                                    />
                                    {previewCrear && (
                                        <div className="imagePreviewWrapper">
                                            <img
                                                src={previewCrear}
                                                alt="Vista previa"
                                                className="imagePreviewImg"
                                            />
                                            <button
                                                type="button"
                                                className="imagePreviewRemove"
                                                onClick={limpiarImagenCrear}
                                                title="Quitar imagen"
                                            >
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        </div>
                                    )}
                                </fieldset>
                            </div>

                            {enviando ? (
                                <button type="button" className="btnLoading" disabled>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Procesando...
                                </button>
                            ) : (
                                <button type="submit" className="btnPost">
                                    Guardar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}

            {/* MODAL EDITAR */}
            {modalEditar && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="deFlexBack">
                            <h4>Editar Quiénes Somos</h4>
                            <span className="close" onClick={cerrarModalEditar}>
                                &times;
                            </span>
                        </div>
                        <form className="sectiontext" onSubmit={handleEditar}>
                            <div className="flexGrap">
                                <fieldset style={{ width: '100%' }}>
                                    <legend>Título</legend>
                                    <input
                                        type="text"
                                        placeholder="Ej: ¿Quiénes Somos? / Misión y Visión"
                                        value={tituloEditar}
                                        onChange={(e) => setTituloEditar(e.target.value)}
                                        required
                                    />
                                </fieldset>

                                <fieldset style={{ width: '100%' }}>
                                    <legend>Descripción</legend>
                                    <textarea
                                        rows="6"
                                        placeholder="Describe la información de Quiénes Somos..."
                                        value={descripcionEditar}
                                        onChange={(e) => setDescripcionEditar(e.target.value)}
                                        required
                                        style={{ resize: 'vertical', minHeight: '120px' }}
                                    />
                                </fieldset>

                                <fieldset style={{ width: '100%' }}>
                                    <legend>Foto / Imagen</legend>

                                    {/* Si hay una foto actual en el servidor y no ha seleccionado una nueva */}
                                    {!previewEditar && imagenActual && (
                                        <div style={{ marginBottom: '10px' }}>
                                            <p style={{ fontSize: '0.8rem', color: '#64748b', margin: '0 0 5px 0' }}>
                                                Foto actual en el servidor:
                                            </p>
                                            <img
                                                src={imagenActual}
                                                alt="Foto actual"
                                                className="imagePreviewImg"
                                            />
                                        </div>
                                    )}

                                    <input
                                        type="file"
                                        accept="image/jpeg,image/png,image/webp,image/gif"
                                        ref={fileInputEditarRef}
                                        onChange={handleImagenEditarChange}
                                    />

                                    {/* Preview de la nueva foto seleccionada */}
                                    {previewEditar && (
                                        <div className="imagePreviewWrapper">
                                            <p style={{ fontSize: '0.8rem', color: '#10b981', margin: '0 0 5px 0', fontWeight: 600 }}>
                                                Nueva foto seleccionada:
                                            </p>
                                            <img
                                                src={previewEditar}
                                                alt="Nueva foto"
                                                className="imagePreviewImg"
                                            />
                                            <button
                                                type="button"
                                                className="imagePreviewRemove"
                                                onClick={limpiarImagenEditar}
                                                title="Cancelar nueva foto"
                                            >
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        </div>
                                    )}
                                </fieldset>
                            </div>

                            {enviando ? (
                                <button type="button" className="btnLoading" disabled>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Actualizando...
                                </button>
                            ) : (
                                <button type="submit" className="btnPost">
                                    Guardar Cambios
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
